import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter028() {
  return <KbChapterPage slug="chapter-028" />;
}

(Chapter028 as unknown as { path: string }).path = "/theory-album/028";
